module.exports = __webpack_public_path__ + "static/media/chef-hat.e4ae1f59.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/chef-hat.svg
// module id = 179
// module chunks = 0